import { Box, IconButton, SxProps } from '@mui/material';
import ArrowLeftLineIcon from 'remixicon-react/ArrowLeftLineIcon';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const $Container = styled(Box, { label: 'Container' })(({ theme }) => ({
  position: 'absolute',
  left: -60,
  top: 0,
  zIndex: 1,
}));

const $FixedPosition = styled(Box, { label: 'FixedPosition' })(({ theme }) => ({
  position: 'fixed',
}));

const $BackButton = styled(IconButton, { label: 'BackButton' })(({ theme }) => ({
  background: theme.palette.custom.white,
  boxShadow: '0 4px 24px rgba(0, 0, 0, 0.04)',
  position: 'sticky',
  left: 0,
  top: 0,
  zIndex: 99999,
}));

type BackPageButtonProps = {
  sx?: SxProps;
  onClick?: () => void;
};

function BackPageButton({ sx, onClick }: BackPageButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <$Container sx={sx}>
      <$FixedPosition>
        <$BackButton onClick={handleClick}>
          <ArrowLeftLineIcon />
        </$BackButton>
      </$FixedPosition>
    </$Container>
  );
}

export default BackPageButton;
